module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/61ba3c80aed48940e6a4a699f1f2f6e6.gif";